import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { Badge, IconButton } from '@mui/material';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import { chatService } from '../../services/chat.service';

/** Shared query key — the SSE stream invalidates it on each new message. */
export const UNREAD_MESSAGES_KEY = ['conversations', 'unread-count'];

/**
 * Header inbox icon with a green badge of the user's total unread messages.
 * Kept live by the SSE notification stream (NotificationBell invalidates
 * {@link UNREAD_MESSAGES_KEY} on every MESSAGE event); the 30s poll is a
 * backstop for any missed push. Clicking opens the inbox.
 */
export function MessagesBell() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const unread = useQuery({
    queryKey: UNREAD_MESSAGES_KEY,
    queryFn: chatService.unreadCount,
    refetchInterval: 30_000,
  });

  return (
    <IconButton
      onClick={() => navigate('/messages')}
      sx={{ ml: 0.5 }}
      aria-label={t('nav.messages')}
    >
      <Badge badgeContent={unread.data ?? 0} color="success" max={99}>
        <ChatBubbleOutlineRoundedIcon />
      </Badge>
    </IconButton>
  );
}
